<template>
  <div :class="['dd-tabs', {'is-pinned': isPinned}]" ref="root">
    <div 
      class="dd-tabs__header">
      <span 
        @click="handleClick(item.name)"
        :class="['dd-tabs__header-item', {'is-active': item.name === active}]"
        v-for="item in panes" :key="item.name">
        {{item.text}}
      </span>
    </div>
    <div class="dd-tabs__body">
      <div 
        class="dd-tabs__pane"
        v-for="item in panes" 
        :key="item.name">
        <slot :name="item.name" v-if="item.name === active"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: [String, Number]
  },
  data () {
    return {
      isPinned: false
    }
  },
  computed: {
    panes () {
      return Object.keys(this.$slots).map(key => ({
        name: key,
        text: this.$slots[key][0].data.attrs.text
      }))
    }
  },
  watch: {
    active () {
      this.$nextTick(() => {
        this.$refs.root.scrollIntoView({
          // behavior: 'smooth'
        })
        // document.documentElement.scrollTop = document.body.scrollTop = this.$refs.root.offsetTop
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleClick (key) {
      this.$emit('update:active', key)
    },
    handleScroll () {
      const bounding = this.$refs.root.getBoundingClientRect()
      this.isPinned = !(bounding.top > 0)
    }
  }
}
</script>

<style lang="scss">
.dd-tabs {
  $headerHeight: 120px;
  $header: #{&}__header;
  $body: #{&}__body;

  #{$header} {
    height: $headerHeight;
    line-height: $headerHeight;
    text-align: center;
    background: #191919;
    font-size: 27px;

    &-item {
      display: inline-block;
      margin: 0 45px;
      color: #fff;
      cursor: pointer;

      &.is-active {
        border-bottom: 4px solid #fff;
      }
    }
  }
  &.is-pinned {
    #{$header} {
      position: fixed;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
    }
    #{$body} {
      padding-top: $headerHeight;
    }
  }

  @include media-tablet {
    $headerHeight: 42px;
    #{$header} {
      height: $headerHeight;
      line-height: $headerHeight;
      font-size: 12px;

      &-item {
        &.is-active {
          border-bottom-width: 2px;
        }
      }
    }
    &.is-pinned {
      #{$body} {
        padding-top: $headerHeight;
      }
    }
  }
}
</style>
